import { render, staticRenderFns } from "./TableUsage.vue?vue&type=template&id=749d6dbc&"
import script from "./TableUsage.vue?vue&type=script&lang=ts&"
export * from "./TableUsage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('749d6dbc', component.options)
    } else {
      api.reload('749d6dbc', component.options)
    }
    module.hot.accept("./TableUsage.vue?vue&type=template&id=749d6dbc&", function () {
      api.rerender('749d6dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ComponentUsage/TableUsage.vue"
export default component.exports